import {
  Alert,
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  InputLabel,
  Typography,
} from "@mui/material";

import useStyles from "./confirmationStyle";
import { useEffect, useState } from "react";
import FormField from "../../../../components/common/FormField";
import {
  clientConfirmationNoteFields,
  clientConfirmationPaymentFields,
  clientConfirmationSelfNoteFields,
  clientInsuranceFields,
  clientInsuranceGeneralFields,
  customerConfirmationNoteFields,
} from "./confirmationAllFields";
import ServiceConfirmation from "./ServiceConfirmation";
import {
  clientConfirm,
  confirmationClientValidateForm,
  confirmationValidateForm,
  staffCategories,
} from "./confirmationUtils";

import DateConfirmation from "./DateConfirmation";
import CustomButton from "../../../../components/common/button/CustomButton";
import closeIcon from "../../../../assets/closeModel.png";
import checkedIcon from "../../../../assets/check-mark.png";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import {
  getConfirmationAction,
  updateConfirmationAction,
} from "../../../../store/reducers/clientConfirmationSlice";
import ConfirmationActions from "./ConfirmationActions";
import Notification from "../../../../components/common/notification/Notification";
import { setNotificationAction } from "../../../../store/reducers/mmymSlice";
import dayjs from "dayjs";
import LeadDetailSection from "../estimate/LeadDetailSection";
import { getLeadColor } from "../../customerInvoice/InvoiceUntil";
import AlertOnSaveConfirmation from "../../manageLeads/AlertOnSaveConfirmation";
import StepLoader from "../../../../components/common/StepLoader";
import Loader from "../../../../components/common/loader/Loader";

interface ManageConfirmationProps {
  show: boolean; // Define the 'open' prop
  onHide?: () => void; // Define the 'onHide' prop
  title?: string; // Define the 'title' prop
  selectLead?: any; // Adjust type as per your requirement
  action?: any;
  setSelectedLead?: any;
  setShow?: any;
  generateId?: any;
}

const ManageConfirmation: React.FC<ManageConfirmationProps> = (props) => {
  const classes = useStyles();
  const [formData, setFormData] = useState(clientConfirm);
  const [isDoorToDoorAccept, setIsDoorToDoorAccept] = useState(true);
  const [isFullPackAccept, setIsFullPackAccept] = useState(true);
  const { onHide, show, setShow, generateId } = props;
  const [alertModelShow, setAlertModelShow] = useState(false);
  const { confirmationDetailsResponse, loaderMessage } = useSelector(
    (state: any) => state.confirmation
  );
  const [actionType, setActionType] = useState("");
  const { leadDetails } = useSelector((state: any) => state.lead);
  const dispatch = useDispatch();
  const [anyChangeFieldValue, setAnyChangeFieldValue] = useState(false);

  const { userProfile } = useSelector((state: any) => state?.user);
  const [isTesterSection, setIsTesterSection] = useState(true);

  useEffect(() => {
    setIsTesterSection(
      userProfile?.features?.includes("Basic Work Diary") || false
    ); // Sync profile changes
  }, [userProfile]);

  useEffect(() => {
    // Function to check if an object is empty
    const isEmptyObject = (obj: any) =>
      Object.keys(obj).length === 0 && obj.constructor === Object;

    if (
      confirmationDetailsResponse &&
      !isEmptyObject(confirmationDetailsResponse)
    ) {
      setFormData(confirmationDetailsResponse);

      // Create a new array with updated service data
      const updatedServices = confirmationDetailsResponse.services;
      const doorTodoor: any = updatedServices?.find(
        (ele: any) => ele?.name === "Removal"
      );
      const fullPack: any = updatedServices?.find(
        (ele: any) => ele?.name === "Full Pack"
      );

      if (doorTodoor) {
        setIsDoorToDoorAccept(doorTodoor?.status !== "accept");
      }
      if (fullPack) {
        setIsFullPackAccept(fullPack?.status !== "accept");
      }
    } else {
      setFormData(clientConfirm);
    }
  }, [confirmationDetailsResponse]);

  useEffect(() => {
    dispatch(getConfirmationAction(generateId));
  }, [dispatch, generateId]);

  const [error, setError] = useState(null);

  const handleSubmit = () =>
    // event: React.MouseEvent<HTMLButtonElement, MouseEvent>
    {
      const { isError, localError } = confirmationClientValidateForm(
        formData,
        isFullPackAccept,
        isDoorToDoorAccept,
        isTesterSection
      );
      // 🧹 Remove movingDate and packingDate errors (if any)
      delete localError.movingDate;
      delete localError.packingDate;
      const hasErrors = Object.keys(localError).length > 0;
      setError(hasErrors ? localError : null);
      setAlertModelShow(false);
      if (!isError) {
        // Format date to "YYYY-MM-DD"
        const formatDate = (date: any) => {
          return date ? dayjs(date).format("YYYY-MM-DD") : null;
        };

        // Create a copy of formData to modify it
        const {
          invoiceNumber,
          invoiceType,
          movingDate,
          packingDate,
          services,
          ...rest
        }: any = formData;

        const formattedServices = services?.map((service: any) => ({
          ...service,
          startDate: formatDate(service.startDate),
          endDate: formatDate(service.endDate),
        }));

        const formPayload = {
          ...rest,
          services: formattedServices,
          generateId,
        };
        if (!actionType || anyChangeFieldValue) {
          dispatch(updateConfirmationAction(formPayload));
          // setShow(false);
          setAnyChangeFieldValue(false);
        }
      }
      setIsShowActionCalled(false);
      setAnyChangeFieldValue(false);
    };

  const [isShowActionCalled, setIsShowActionCalled] = useState(false);

  useEffect(() => {
    if (isShowActionCalled) {
      handleSubmit();
      setIsShowActionCalled(false);
    }
  }, [isShowActionCalled]);

  const isDisabled =
    leadDetails?.lead?.status === "COMPLETED" ||
    leadDetails?.lead?.status === "JOB";

  const isCheckedQuoteStatus = leadDetails?.lead?.status === "QUOTE";

  return (
    <>
    {/* {formData?.isQuoteAccepted && (
      <>
      </>
    )} */}
      {loaderMessage !== "" && <Loader />}
      {alertModelShow && (
        <AlertOnSaveConfirmation
          open={alertModelShow}
          title="Confirmation"
          onHide={() => setAlertModelShow(false)}
          setAlertModelShow={setAlertModelShow}
          submitHandler={handleSubmit}
        />
      )}
      <div
        id="estimate-popup-fixed"
        className={classes.estimatePopupContainer}
        style={{
          zIndex: show ? 11 : -1,
        }}
      >
        <Grid container spacing={2}>
          <Grid
            item
            xs={12}
            sm={12}
            sx={{ height: "45px", zIndex: 99, paddingLeft: "0px" }}
          >
            <div className={classes.popupTitle} style={{ padding: "4px 10px" }}>
              <Box
                sx={{
                  display: "inline-block",
                  px: 3,
                  py: 1,
                  backgroundColor: getLeadColor("CONFIRMED"),
                  color: "white",
                  clipPath:
                    "polygon(75% 0%, 100% 50%, 75% 100%, 0% 100%, 25% 50%, 0% 0%)",
                }}
              >
                <Typography
                  sx={{
                    fontSize: "14px",
                    marginLeft: "2px",
                    paddingLeft: "6px !important",
                  }}
                  variant="subtitle1"
                >
                  Confirm
                </Typography>
              </Box>
              <Typography
                sx={{
                  fontSize: "20px",
                  color: getLeadColor("CONFIRMED"),
                }}
                variant="subtitle1"
              >
                Confirmation
              </Typography>
              <Box>
                {leadDetails?.lead?.status === "COMPLETED" ||
                leadDetails?.lead?.status === "JOB" ||
                isDoorToDoorAccept ? (
                  ""
                ) : (
                  <img
                    onClick={(e) =>
                      isCheckedQuoteStatus
                        ? setAlertModelShow(true)
                        : handleSubmit()
                    }
                    src={checkedIcon}
                    style={{
                      cursor: "pointer",
                      height: "26px",
                      width: "26px",
                      marginRight: 10,
                    }}
                    alt="save"
                  />
                )}
                <img
                  src={closeIcon}
                  style={{ cursor: "pointer", height: "26px", width: "26px" }}
                  onClick={() => {
                    setShow(false);
                    dispatch(
                      setNotificationAction({ message: [], severity: "error" })
                    );
                  }}
                  alt="cross-icon"
                />
              </Box>
              {/* <CustomButton
                title="Return"
                onClick={() => {
                  setShow(false);
                  dispatch(
                    setNotificationAction({ message: [], severity: "error" })
                  );
                  // setEstimateForm(null)
                  // setError(null)
                }}
              /> */}
            </div>
          </Grid>
          <Grid item xs={12} sm={12} sx={{ paddingLeft: "0px !important" }}>
            <Notification />
            <Grid container spacing={0.5} sx={{ fontSize: "13px" }}>
              <Grid
                item
                xs={12}
                sm={12}
                sx={{
                  paddingLeft: "0px !important",
                  paddingTop: "0px !important",
                }}
              >
                <LeadDetailSection
                  leadDetails={leadDetails}
                  fontSize={"13px"}
                />
              </Grid>
            </Grid>
          </Grid>
        </Grid>
        <Grid
          container
          spacing={0.5}
          sx={{
            background: "#E5F4F1",
            borderRadius: "5px",
            border: "1px solid #CFCFCF",
            overflow: "hidden",
            mt: 1,
            pointerEvents: isDisabled ? "none" : "auto", // disable clicks
            cursor: isDisabled ? "not-allowed" : "default", // show not-allowed cursor
            // opacity: isDisabled ? 0.6 : 1, // optional: visually show disabled
          }}
        >
          <Grid item xs={12} md={5} sx={{ paddingLeft: "0px !important" }}>
            <ServiceConfirmation
              error={error}
              formData={formData}
              setFormData={setFormData}
              setError={setError}
              isDisabled={""}
              setIsDoorToDoorAccept={setIsDoorToDoorAccept}
              setIsFullPackAccept={setIsFullPackAccept}
              setAnyChangeFieldValue={setAnyChangeFieldValue}
            />
          </Grid>
          <Grid item md={7} sx={{ paddingLeft: "0px !important" }}>
            <DateConfirmation
              error={error}
              formData={formData}
              setFormData={setFormData}
              isDisabled={""}
              isDoorToDoorAccept={isDoorToDoorAccept}
              isFullPackAccept={isFullPackAccept}
              setAnyChangeFieldValue={setAnyChangeFieldValue}
            />
          </Grid>
        </Grid>
        <Grid container spacing={0.5} sx={{ marginTop: "4px" }}>
          {/* Insurance UI */}
          <Grid
            container
            spacing={1.5}
            sx={{
              marginLeft: "0px !important",
              width: "100% !important",
              paddingLeft: "10px !important",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #CFCFCF",
              overflow: "hidden",
              mt: 1,
            }}
          >
            <Grid
              item
              xs={12}
              sm={1.5}
              alignItems="center"
              sx={{
                margin: "0!important",
                display: "flex",
                alignItems: "center",
                paddingLeft: "0px !important",
              }}
            >
              <InputLabel
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: "18px",
                  textWrap: "wrap",
                  lineHeight: 1.1,
                }}
                shrink
                htmlFor={"paymentMethod"}
              >
                Insurance :
              </InputLabel>
            </Grid>
            <Grid
              item
              xs={12}
              md={1.6}
              sx={{
                display: "flex",
                paddingLeft: "0px !important",
                paddingRight: "10px !important",
              }}
            >
              <Grid
                container
                spacing={0}
                sx={{
                  display: "flex",
                  marginTop: "0px",
                }}
              >
                <>
                  {clientInsuranceGeneralFields.map(
                    (field: any, idx: number) => {
                      return (
                        <FormField
                          key={idx}
                          onPaste={(
                            e: React.ClipboardEvent<HTMLInputElement>
                          ) => e.preventDefault()}
                          {...{
                            ...field,
                            variant: "outlined", // Adding this variant prop
                            isNonMarginTop: true,
                            value: confirmationDetailsResponse
                              ? confirmationDetailsResponse?.[field?.id]
                              : "",
                            disabled: true,
                            inSingleGridForm: true,
                            InputProps: {
                              ...(field?.inputProps && field?.inputProps),
                              autocomplete: "off",

                              sx: {
                                padding: "2px 4px",
                                height: "36px",
                                // width:'120px'
                              },
                            },
                          }}
                        />
                      );
                    }
                  )}
                </>
              </Grid>
            </Grid>
            <Grid
              item
              xs={12}
              md={8.4}
              sx={{
                display: "flex",
                justifyContent: "flex-start",
                paddingLeft: "0px !important",
              }}
            >
              {clientInsuranceFields.map((field: any, idx: number) => {
                return (
                  <FormField
                    key={idx}
                    onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                      e.preventDefault()
                    }
                    {...{
                      ...field,
                      type: field?.type,
                      variant: "outlined", // Adding this variant prop
                      isNonMarginTop: true,
                      value: confirmationDetailsResponse
                        ? confirmationDetailsResponse?.[field?.id]
                        : "",
                      disabled: true,
                      inSingleGridForm: true,
                      GridFieldStyle: {
                        paddingRight: "10px !important",
                      },
                      InputProps: {
                        ...field?.inputProps,
                        autocomplete: "off",
                        startAdornment: (
                          <span
                            style={{
                              marginRight: "0px",
                              paddingTop: "1px",
                              fontWeight: 600,
                              fontSize: "14px",
                            }}
                          >
                            £
                          </span>
                        ),
                        sx: {
                          padding: "2px 4px",
                          height: "36px",
                          // width: "120px",
                        },
                      },
                    }}
                  />
                );
              })}
            </Grid>

            {clientConfirmationPaymentFields.map((field: any, id: any) => {
              // special case for type === "label"
              if (field.type === "label") {
                return (
                  <Grid
                    key={id}
                    item
                    xs={12}
                    sm={field.md || 1.5}
                    className={classes.labelBox}
                    sx={{
                      margin: "10!important",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "0px !important",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                        textWrap: "wrap",
                        lineHeight: 1.1,
                      }}
                      shrink
                    >
                      {field.label}
                    </InputLabel>
                  </Grid>
                );
              }

              return (
                <FormField
                  key={field.id}
                  onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                    e.preventDefault()
                  }
                  {...{
                    ...field,
                    id: field?.id,
                    variant: "outlined", // Adding this variant prop
                    isNonMarginTop: true,
                    value: confirmationDetailsResponse
                      ? confirmationDetailsResponse?.[field?.id]
                      : "",
                    // options: ['Go Cardless'],
                    disabled: true,
                    inSingleGridForm: true,
                    GridFieldStyle: {
                      paddingLeft: "0px !important",
                    },
                    InputProps: {
                      sx: {
                        padding: "2px 4px",
                        height: "36px",
                      },
                    },
                  }}
                />
              );
            })}
            {/*property size  */}
            <Grid
              item
              xs={12}
              md={2.5}
              // className={classes.labelBox}
              alignItems="center"
              sx={{
                display: "flex",
                alignItems: "center",
                // marginLeft:'4px'
              }}
            >
              <InputLabel
                sx={{
                  color: "#333333",
                  fontWeight: 600,
                  fontSize: "17px",
                  textWrap: "wrap",
                  lineHeight: 1,
                }}
                shrink
                htmlFor={""}
              >
                Existing property Size :
              </InputLabel>
              {/* Drivers */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  paddingTop: "0px",
                }}
              >
                <Typography variant="subtitle1" sx={{ mr: "4px" }}>
                  {formData?.collectionAddresses
                    ? formData?.collectionAddresses[0]?.volume
                      ? formData?.collectionAddresses[0]?.volume
                      : "0"
                    : "0"}
                </Typography>
                <Typography variant="body1">
                  {formData?.collectionAddresses
                    ? formData?.collectionAddresses[0]?.volume_unit
                      ? formData?.collectionAddresses[0]?.volume_unit
                      : ""
                    : ""}
                </Typography>
              </Box>
            </Grid>
          </Grid>

          {/* notes */}
          <Grid
            container
            spacing={1.5}
            sx={{
              marginTop: "10px",
              marginLeft: "0px !important",
              width: "100% !important",
              padding: "0px 10px 10px 0px",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #CFCFCF",
            }}
          >
            {clientConfirmationNoteFields.map((field: any, idx: number) => {
              // special case for type === "title"
              if (field.type === "title") {
                return (
                  <Grid
                    key={idx}
                    item
                    xs={12}
                    sm={field.md || 1.5}
                    className={classes.labelBox}
                    sx={{
                      margin: "10!important",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px !important",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                        textWrap: "wrap",
                        lineHeight: 1.1,
                      }}
                      shrink
                    >
                      {field.label} :
                    </InputLabel>
                  </Grid>
                );
              }
              return (
                <FormField
                  // key={field.id}
                  onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                    e.preventDefault()
                  }
                  {...{
                    ...field,
                    id: field?.id,
                    // type: "textarea",
                    variant: "outlined", // Adding this variant prop
                    isNonMarginTop: true,
                    value: confirmationDetailsResponse
                      ? confirmationDetailsResponse?.[field?.id]
                      : "",
                    inSingleGridForm: true,
                    disabled: true,
                    editReadOnly: true,
                    multiline: true,
                    minRows: 2,
                    InputProps: {
                      sx: {
                        padding: "2px 4px",
                        height: "36px",
                        resize: "none",
                        // marginBottom: "6px !important",
                      },
                    },
                    GridLabelStyle: {
                      height: "46%",
                      marginBottom: "10px",
                    },
                    InputLabelProps: {
                      sx: {
                        WrapText: "normal",
                        whiteSpace: "pre-wrap",
                        // height: 'calc(100%)',
                        height: "auto",
                      },
                    },
                  }}
                />
              );
            })}
          </Grid>
          {/* customer notes */}

          <Grid
            container
            spacing={1.5}
            sx={{
              marginTop: "8px",
              marginLeft: "0px !important",
              width: "100% !important",
              padding: "0px 10px 10px 0px",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #CFCFCF",
            }}
          >
            {customerConfirmationNoteFields.map((field: any, idx: number) => {
              // special case for type === "title"
              if (field.type === "title") {
                return (
                  <Grid
                    key={idx}
                    item
                    xs={12}
                    sm={field.md || 1.5}
                    className={classes.labelBox}
                    sx={{
                      margin: "10!important",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px !important",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                        textWrap: "wrap",
                        lineHeight: 1.1,
                      }}
                      shrink
                    >
                      {field.label} :
                    </InputLabel>
                  </Grid>
                );
              }
              return (
                <FormField
                  // key={field.id}
                  onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                    e.preventDefault()
                  }
                  {...{
                    ...field,
                    id: field?.id,
                    // type: "textarea",
                    variant: "outlined", // Adding this variant prop
                    isNonMarginTop: true,
                    value: confirmationDetailsResponse
                      ? confirmationDetailsResponse?.[field?.id]
                      : "",
                    // options: ['Go Cardless'],
                    disabled: true,
                    editReadOnly: true,
                    inSingleGridForm: true,
                    multiline: true,
                    minRows: 1.5,
                    InputProps: {
                      sx: {
                        padding: "2px 4px",
                        height: "36px",
                        resize: "none",
                        // marginBottom: "6px !important",
                      },
                    },
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                      setFormData({
                        ...formData,
                        [field?.id]: e.target.value, // Fix: Ensure value updates properly
                      });
                      setAnyChangeFieldValue(true);
                    },
                    GridLabelStyle: {
                      height: "54%",
                      marginBottom: "10px",
                    },
                    InputLabelProps: {
                      sx: {
                        WrapText: "normal",
                        whiteSpace: "pre-wrap",
                        // height: 'calc(100%)',
                        height: "auto",
                      },
                    },
                  }}
                />
              );
            })}
          </Grid>

          {/* notes */}
          <Grid
            container
            spacing={1.5}
            sx={{
              marginTop: "8px",
              marginBottom: "8px",
              marginLeft: "0px !important",
              width: "100% !important",
              padding: "0px 10px 10px 0px",
              background: "#E5F4F1",
              borderRadius: "5px",
              border: "1px solid #CFCFCF",
              pointerEvents: isDisabled ? "none" : "auto", // disable clicks
              cursor: isDisabled ? "not-allowed" : "default", // show not-allowed cursor
              // opacity: isDisabled ? 0.6 : 1, // optional: visually show disabled
            }}
          >
            {clientConfirmationSelfNoteFields.map((field: any, idx: number) => {
              // special case for type === "title"
              if (field.type === "title") {
                return (
                  <Grid
                    key={idx}
                    item
                    xs={12}
                    sm={field.md || 1.5}
                    className={classes.labelBox}
                    sx={{
                      margin: "10!important",
                      display: "flex",
                      alignItems: "center",
                      paddingLeft: "10px !important",
                    }}
                  >
                    <InputLabel
                      sx={{
                        color: "#333333",
                        fontWeight: 600,
                        fontSize: "18px",
                        textWrap: "wrap",
                        lineHeight: 1.1,
                      }}
                      shrink
                    >
                      {field.label} :
                    </InputLabel>
                  </Grid>
                );
              }
              return (
                <FormField
                  // key={field.id}
                  onPaste={(e: React.ClipboardEvent<HTMLInputElement>) =>
                    e.preventDefault()
                  }
                  {...{
                    ...field,
                    id: field?.id,
                    // type: "textarea",
                    variant: "outlined", // Adding this variant prop
                    isNonMarginTop: true,
                    value: confirmationDetailsResponse
                      ? confirmationDetailsResponse?.[field?.id]
                      : "",
                    inSingleGridForm: true,
                    // options: ['Go Cardless'],
                    // disabled: true,
                    // editReadOnly: true,
                    multiline: true,
                    // minRows: 3,
                    InputProps: {
                      sx: {
                        padding: "2px 4px",
                        height: "36px",
                        resize: "none",
                        // marginBottom: "6px !important",
                      },
                    },
                    onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
                      setFormData({
                        ...formData,
                        [field?.id]: e.target.value, // Fix: Ensure value updates properly
                      });
                      setAnyChangeFieldValue(true);
                    },
                    GridLabelStyle: {
                      height: "56%",
                      marginBottom: "10px",
                    },
                    InputLabelProps: {
                      sx: {
                        WrapText: "normal",
                        whiteSpace: "pre-wrap",
                        // height: 'calc(100%)',
                        height: "auto",
                      },
                    },
                  }}
                />
              );
            })}
          </Grid>
          {formData?.isDepositeRecieved && formData?.invoiceNumber !== null && (
            <FormControlLabel
              label="Deposit received"
              labelPlacement="end"
              control={
                <Checkbox
                  sx={{
                    marginTop: "0",
                    marginLeft: "0 !important",
                    width: "auto !important",
                  }}
                  checked={formData?.isDepositeRecieved}
                  disabled={true}
                  onChange={(event) => {
                    setFormData({
                      ...formData,
                      isDepositeRecieved: event.target.checked,
                    });
                    setAnyChangeFieldValue(true);
                  }}
                  name="isDepositeRecieved"
                  id="isDepositeRecieved"
                  color="primary"
                />
              }
              sx={{
                "& .MuiFormControlLabel-label": {
                  fontSize: "16px", // Set your desired font size here
                  display: "flex",
                },
              }}
            />
          )}
          <br />
          {formData?.isDepositAmountExceeds && (
            <Alert severity="error" sx={{ mb: 2, width: "100%" }}>
              Deposit received is more than quotation cost. please! update
              deposit invoice, for job confirmation.
            </Alert>
          )}
          {formData?.invoiceNumber && !formData?.isDepositeRecieved && (
            <Alert severity="info" sx={{ mb: 2, width: "100%" }}>
              Deposit Invoice is not paid.
            </Alert>
          )}
          <Alert severity="info" sx={{ mb: 1, width: "100%" }}>
            You will have to resend the quotation if any of the services is
            marked Not Taking.
          </Alert>
          {/* buttons */}
          <div
            style={{
              position: "fixed",
              borderTop: "1px solid #CCC",
              left: 100,
              bottom: 48,
              right: 100,
              background: "#FFF",
              // display: "flex",
              // justifyContent: "space-between",
              padding: "10px 20px",
              zIndex: 1,
            }}
          >
            <div style={{ paddingLeft: "19px" }}>
              {/* <CustomButton
                style={{ marginRight: "10px" }}
                title="Save"
                disabled={
                  leadDetails?.lead?.status === "COMPLETED" ||
                  leadDetails?.lead?.status === "JOB" ||
                  isDoorToDoorAccept
                    ? true
                    : false
                }
                onClick={(e) => handleSubmit()}
              /> */}
              <ConfirmationActions
                confirmationForm={formData}
                screenType={"confirmation"}
                isShowActionCalled={isShowActionCalled}
                setIsShowActionCalled={setIsShowActionCalled}
                setAnyChangeFieldValue={setAnyChangeFieldValue}
                anyChangeFieldValue={anyChangeFieldValue}
                setActionType={setActionType}
                actionType={actionType}
              />
              {/* <CustomButton
                title="Return"
                onClick={() => {
                  setFormData(clientConfirm);
                  setShow(false);
                  // setError(null)
                }}
              /> */}
              {/* {(selectedLeadEstimate || load) &&  */}
              <FormControlLabel
                label="VAT Included"
                labelPlacement="start"
                control={
                  <Checkbox
                    name="vatIncluded"
                    id="vatIncluded"
                    sx={{
                      marginTop: "0",
                      marginLeft: "0 !important",
                      width: "auto !important",
                    }}
                    checked={formData?.vatIncluded}
                    disabled={true}
                    onChange={(event) => {
                      setFormData({
                        ...formData,
                        vatIncluded: event.target.checked,
                      });
                    }}
                    color="primary"
                  />
                }
                sx={{
                  "& .MuiFormControlLabel-label": {
                    fontSize: "13px", // Set your desired font size here
                    display: "flex",
                  },
                }}
              />
              {/* } */}
            </div>
          </div>
        </Grid>
      </div>
    </>
  );
};
export default ManageConfirmation;
